<div class="help-page">
  <div class="help-card hero">
    <span class="badge">Documentos de utilização</span>
    <h1>Guia rápido do PeritoDesk</h1>
    <p>Instruções objetivas para usar a versão atual.</p>
  </div>

  <div class="help-grid">
    <div class="help-card" *ngFor="let passo of passos">
      <h2>{{ passo.titulo }}</h2>
      <p>{{ passo.texto }}</p>
    </div>
  </div>

  <div class="help-card">
    <h2>Observação</h2>
    <p>Os documentos completos também ficam nos arquivos README dentro do diretório do projeto.</p>
  </div>
</div>
